module.exports = "/images/fullsize-icon.svg?d080f78a5ee3328f3e6b8cc1797e20ec";